import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function JoinQuestionnaire() {
  const {
    t
  } = useLanguage();
  const email = 'jose@danceforfans.com';
  return <section className="py-24 px-6 bg-zinc-950 border-y border-zinc-900" data-id="element-94">
      <div className="max-w-2xl mx-auto" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-96">
          <p className="text-sm uppercase tracking-widest text-zinc-500 font-medium mb-4" data-id="element-97">
            {t('join.tag')}
          </p>
          <h2 className="font-serif text-3xl md:text-4xl mb-4 text-zinc-100" data-id="element-98">
            {t('join.title')}
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-99">{t('join.subtitle')}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-zinc-900/50 border border-zinc-800 rounded-3xl p-8 md:p-12 text-center" data-id="element-100">
          <p className="font-serif text-2xl md:text-3xl text-zinc-100 mb-8 leading-snug" data-id="element-101">
            Email any questions to{' '}
            <a href={`mailto:${email}`} className="text-emerald-400 hover:text-emerald-300 underline underline-offset-4 transition-colors" data-id="element-102">
              {email}
            </a>
          </p>

          <motion.div animate={{
          boxShadow: ['0 0 0 0 rgba(16, 185, 129, 0.45)', '0 0 0 10px rgba(16, 185, 129, 0)', '0 0 0 0 rgba(16, 185, 129, 0)'],
          scale: [1, 1.01, 1]
        }} transition={{
          duration: 2.8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block rounded-full" data-id="element-103">
            
          </motion.div>
        </motion.div>
      </div>
    </section>;
}